import { frontendURL } from '../../../helper/URLHelper';

// Reuse existing components from reports
import ReportsWrapper from '../settings/reports/components/ReportsWrapper.vue';
import LiveReports from '../settings/reports/LiveReports.vue';
import Index from '../settings/reports/Index.vue';
import AgentReports from '../settings/reports/AgentReports.vue';
import CsatReports from '../settings/reports/CsatResponses.vue';
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/simplified-reports'),
      component: ReportsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'custom_report', params: to.params };
          },
        },
        {
          path: 'simplified-overview',
          name: 'simplified_account_overview_reports',
          meta: {
            permissions: ['administrator', 'report_manage', 'agent'],
          },
          component: LiveReports,
        },
        {
          path: 'simplified-conversation',
          name: 'simplified_conversation_reports',
          meta: {
            permissions: ['administrator', 'report_manage', 'agent'],
          },
          component: Index,
        },
        {
          path: 'simplified-agent',
          name: 'simplified_agent_reports',
          meta: {
            permissions: ['administrator', 'report_manage', 'agent'],
          },
          component: AgentReports,
        },
        {
          path: 'simplified-csat',
          name: 'simplified_csat_reports',
          meta: {
            permissions: ['administrator', 'report_manage', 'agent'],
          },
          component: CsatReports,
        },
      ],
    },
  ],
};
